module.exports = __webpack_public_path__ + "static/media/webdesign-services-img11.25424406.jpg";